import { render, staticRenderFns } from "./FormOriginSystem.vue?vue&type=template&id=c719a11c"
import script from "./FormOriginSystem.vue?vue&type=script&lang=js"
export * from "./FormOriginSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports